import { put } from 'redux-saga/effects';

import connectionStatusUpdate from './druid/actions/connectionStatusUpdate';
import observeEach from '/druid/effects/observeEach';
import setReferenceGrammarID from './druid/actions/setReferenceGrammarID';
import whileConnected from '/druid/effects/whileConnected';

function* observeConnectionStatus({ directLine }) {
  yield observeEach(directLine.connectionStatus$, function* updateConnectionStatus(connectionStatus) {
    yield put(connectionStatusUpdate(connectionStatus));
    yield put(setReferenceGrammarID(directLine.referenceGrammarId));
  });
}

export default function* connectionStatusUpdateSaga() {
  yield whileConnected(observeConnectionStatus);
}
